import { getResponse, graphql, type GraphQLHandler, type HttpHandler, HttpResponse, http as msw_http } from "msw";
import invariant from "tiny-invariant";

const base = graphql.link("/graphql/");
export const graphqlHandlers: (HttpHandler | GraphQLHandler)[] = [
    base.query("GetVmList", async (_r) => {
        const { getVmListQueryExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getVmListQueryExample });
    }),

    base.query("GetBillingAccountList", async (_r) => {
        const { getBillingAccountListQueryExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getBillingAccountListQueryExample });
    }),

    base.query("GetBillingAccountById", async ({ variables: { id } }) => {
        invariant(typeof id === "string", "Expected string id");
        const { getBillingAccountByIdExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getBillingAccountByIdExample(id) });
    }),

    base.query("GetUserDetails", async (_r) => {
        const { getUserDetailsQueryExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getUserDetailsQueryExample });
    }),

    base.query("GetUserList", async (_r) => {
        const { getUserListQueryExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getUserListQueryExample });
    }),

    base.query("GetBucketList", async (_r) => {
        const { getBucketListQueryExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getBucketListQueryExample });
    }),

    base.query("GetServicePackageList", async (_r) => {
        const { getServicePackageListQueryExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getServicePackageListQueryExample });
    }),

    base.query("GetLoadBalancerList", async (_r) => {
        const { getLoadBalancerListQueryExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getLoadBalancerListQueryExample });
    }),

    base.query("GetIpAddressList", async (_r) => {
        const { getIpAddressListQueryExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getIpAddressListQueryExample });
    }),

    base.query("GetInvoiceList", async (_r) => {
        const { getInvoiceListQueryExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getInvoiceListQueryExample });
    }),

    base.query("GetRevenueInvoiceList", async (_r) => {
        const { getInvoiceListQueryExample } = await import("@/mock-api/data/graphqlExamples.ts");
        return HttpResponse.json({ data: getInvoiceListQueryExample });
    }),

    base.operation(({ operationName }) => {
        return HttpResponse.json({
            errors: [{ message: `Unhandled GraphQL operation: ${operationName}` }],
        });
    }),

    // Based on: https://mswjs.io/docs/graphql/mocking-responses/query-batching
    // [Support batched GraphQL queries](https://github.com/mswjs/msw/issues/510)
    msw_http.post("/graphql", async ({ request }) => {
        const requestClone = request.clone();
        const payload = await requestClone.json();

        // Ignore non-batched GraphQL queries.
        if (!Array.isArray(payload)) {
            return;
        }

        const responses = await Promise.all(
            payload.map(async (query) => {
                // Construct an individual query request to the same URL but with an unwrapped query body.
                const queryRequest = new Request(requestClone, {
                    body: JSON.stringify(query),
                });

                // Resolve the individual query request against the list of request handlers.
                const response = await getResponse(graphqlHandlers, queryRequest);
                invariant(response, "No response handler for GraphQL query");
                return response;
            }),
        );

        // Read the mocked response JSON bodies to use in the response to the entire batched query.
        const queryData = await Promise.all(responses.map((response) => response.json()));

        return HttpResponse.json(queryData);
    }),
];
